import { render, staticRenderFns } from "./RadialbarChart.vue?vue&type=template&id=5686642c"
import script from "./RadialbarChart.vue?vue&type=script&lang=js"
export * from "./RadialbarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports